// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getInactiveAdsApi} from "../../Service/Api/InactiveAdsApi";
import { getInactiveAds,getErrors } from "../Reducer/InactiveAdsReducer";


 

// Watchers
function* inactiveAdsSaga() {
	yield takeEvery("inactive_ads/getInactiveAds", getAllInactiveAds)
}

// Sagas
function* getAllInactiveAds(action) {
 
	try {
		const getAdsData = yield call(getInactiveAdsApi, action.payload)
	 
		if (getAdsData.request.status === 200) {
			yield put(getInactiveAds(getAdsData))
		 
		} else {
         
			yield put(getErrors(true))
		}
	} catch (error) {
     
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(inactiveAdsSaga)])
}
